import React from 'react';
import { MessageSquareX, AlertCircle, Frown, Clock, MousePointerClick } from 'lucide-react';
export function ProblemAgitation() {
  return <section className="py-20 bg-surface" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-graphite mb-6" data-id="element-146">
            El ciclo sin fin de los resultados genéricos
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto text-left md:text-center italic" data-id="element-147">
            "¿Te ha pasado? Alguien te pregunta emocionada por el precio de tu
            producto o servicio. Tú respondes con toda la amabilidad del mundo,
            das el detalle, envías el costo... y de repente, el silencio
            absoluto. Te dejaron en 'Visto'. Otra vez."
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10 mb-12 relative overflow-hidden" data-id="element-148">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-bl-full -z-10" data-id="element-149"></div>

          <ul className="space-y-6" data-id="element-150">
            {[{
            icon: MessageSquareX,
            text: "Te piden 'precio' y cuando respondes… desaparecen"
          }, {
            icon: Clock,
            text: 'Te quedas revisando el celular como si la venta dependiera de tu ansiedad'
          }, {
            icon: Frown,
            text: "Te esfuerzas por escribir 'bonito' y igual sientes que suena a rogadera"
          }, {
            icon: AlertCircle,
            text: 'Mandas párrafos largos y la conversación se muere antes de que el cliente entienda'
          }, {
            icon: MousePointerClick,
            text: "Dices 'el link está en mi bio' y el cliente se pierde en otra pestaña"
          }].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-151">
                <div className="bg-red-50 p-2 rounded-lg flex-shrink-0 mt-1" data-id="element-152">
                  <item.icon className="w-6 h-6 text-red-500" data-id="element-153" />
                </div>
                <p className="text-lg text-gray-700 font-medium pt-1" data-id="element-154">
                  {item.text}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="prose prose-lg max-w-none text-gray-600 mb-12" data-id="element-155">
          <p className="text-xl font-medium text-graphite border-l-4 border-primary pl-6 py-2" data-id="element-156">
            El problema no es tu precio. El problema es que estás usando
            tácticas de venta de 1990 en una era de gratificación instantánea.
            Si el cliente siente presión o aburrimiento, cierra el chat.
          </p>
          <p className="mt-6 text-lg" data-id="element-157">
            Si te reconoces, no es que "no sepas vender": es que nadie te enseñó
            un sistema moderno para abrir y cerrar conversaciones en segundos.
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200" data-id="element-158">
          <h3 className="font-heading font-bold text-xl text-graphite mb-6 flex items-center gap-2" data-id="element-159">
            <AlertCircle className="w-6 h-6 text-orange-500" data-id="element-160" />
            Por qué lo típico falla
          </h3>
          <ul className="space-y-4" data-id="element-161">
            {["Ser 'ultra amable' con mil emojis huele a desesperación y ahuyenta compradores serios", 'Dar el precio de inmediato sin calificar te convierte en catálogo, no en autoridad', "Enviar textos tipo 'Wikipedia' abruma y el cliente elige NO decidir"].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-162">
                <div className="w-1.5 h-1.5 rounded-full bg-orange-500 mt-2.5 flex-shrink-0" data-id="element-163"></div>
                <span className="text-gray-700" data-id="element-164">{bullet}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}